// Console utility - disable all console output in production
// Development (npm start) me logs normal rahenge, sirf production build me band honge

const isDevelopment = process.env.NODE_ENV === 'development';

// Override console methods in production (browser only)
if (!isDevelopment && typeof window !== 'undefined') {
  const noop = () => {};

  // Disable *all* console methods in production
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
  console.error = noop;
}

// Safe loggers for development use
export const safeLog = (...args) => {
  if (isDevelopment) {
    console.log(...args);
  }
};

export const safeError = (...args) => {
  if (isDevelopment) {
    console.error(...args);
  }
};

export const safeWarn = (...args) => {
  if (isDevelopment) {
    console.warn(...args);
  }
};

export default {
  log: safeLog,
  error: safeError,
  warn: safeWarn,
};

